import React from 'react';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import Header from '../../Component/Header';
import { LeftMenu } from '../../Component/LeftMenu';
import BaseScreen from './BaseScreen';
import { SCREENS } from '../../constants/screens.constant';
import axios from 'axios';
import Home from './home/Home';
import MyAccountHolders from './users/MyAccountHolders';
import MyOperators from './users/MyOperators';
import UserVehicles from './user-vehicles/UserVehicles';
import Tasks from './tasks/Tasks';
import Calibrations from './calibrations/Calibrations';
import Crops from './crops/Crops';
import Operations from './operations/Operations';
import { AppStorageHelper } from '../../shared/utils/appStorageHelper';
import AppInfoHelper from '../../shared/utils/appInfoHelper';
import { updateUserInfo } from '../../redux/actions/action.userinfo';
import { getSelectedAccHolder } from '../../redux/actions/action.accholderinfo';
import { ROLE_TYPES, APP_BUILD_VERSION } from '../../constants/app.constants';
import LoadingOverlay from '../../Component/loader/LoadingOverlay';

const routes = [
  { path: '/home', component: Home }
];

/**
 * Default layout component.
 */
class DefaultLayout extends BaseScreen {
  constructor (props) {
    super(props);

    let isAuthenticated = true;

    if (!this.isAuth()) {
      isAuthenticated = false;
      this.goToScreen(SCREENS.login);
    }
    this.state = {
      isAuthenticated: isAuthenticated,
      isAuthorizedForCustomerPortal: false,
      isLoading: true,
      isErrorOnLoad: false,
      isErrorOnMenuItemsLoad: false,
      onLoadErrorMsg: ''
    };

    this.navItems = [];
  }

  /**
   * during the mount this function get user information, load menu items to render as left menu.
   */
  componentDidMount () {
    var that = this;

    /**
     * get userInfo
     */
    if (this.state.isAuthenticated) {
      const userInfoInstance = AppInfoHelper.getUserInstance();
      userInfoInstance.getUserInfo().then(function (response) {
        const loggenInUserInfo = response;

        if (loggenInUserInfo.roleId === ROLE_TYPES.ACCOUNT_HOLDER.ID ||
          loggenInUserInfo.roleId === ROLE_TYPES.OPERATOR.ID) {
          that.setState({
            isAuthorizedForCustomerPortal: true
          });

          /**
           * udpate redux store
           */
          that.props.updateUserInfo(response);
          if (loggenInUserInfo.roleId === ROLE_TYPES.OPERATOR.ID) {
            that.props.getSelectedAccHolder();
          }

          /**
           * loading menuitems from http
           */
          axios.get('./config/menuItems.json?preventCaching=' + APP_BUILD_VERSION)
            .then(function (response) {
              if (loggenInUserInfo.roleId === ROLE_TYPES.ACCOUNT_HOLDER.ID) {
                that.navItems = response.data.accountHolderMenus;
              } else if (loggenInUserInfo.roleId === ROLE_TYPES.OPERATOR.ID) {
                that.navItems = response.data.operatorMenus;
              }
              that.prepareRoutes();
            }, function (error) {
              const errorMsg = i18n.t('common.menuItemsLoadError');
              that.setState(
                {
                  isLoading: false,
                  isErrorOnMenuItemsLoad: true,
                  onLoadErrorMsg: errorMsg
                });
            });
        } else {
          that.setState({
            isAuthorizedForCustomerPortal: false,
            isLoading: false
          });
        }
      }, function (error) {
        let errorMsg = i18n.t('common.genericApiError');
        if (error && error.data && error.data.message) {
          errorMsg = error.data.message;
        }
        that.setState(
          {
            isLoading: false,
            isErrorOnLoad: true,
            onLoadErrorMsg: errorMsg
          });
      });
    }
  }

  /**
   * prepare routing information and land to respective main component of module.
   * each subsequest sub component routing takes place from the main component of respective module.
   */
  prepareRoutes () {
    this.navItems.map((item, idx) => {
      if (item.key === 'myOperators') {
        routes.push({ path: '/operators', component: MyOperators });
      } else if (item.key === 'myAccountHolders') {
        routes.push({ path: '/account-holders', component: MyAccountHolders });
      } else if (item.key === 'myVehicles') {
        routes.push({ path: '/user-vehicles', component: UserVehicles });
      } else if (item.key === 'myTasks') {
        routes.push({ path: '/tasks', component: Tasks });
      } else if (item.key === 'calibrations') {
        routes.push({ path: '/calibrations', component: Calibrations });
      } else if (item.key === 'myCrops') {
        routes.push({ path: '/crops', component: Crops });
      } else if (item.key === 'myOperations') {
        routes.push({ path: '/operations', component: Operations });
      }
      return true;
    });

    this.setState({ isLoading: false });
  }

  /**
   * render left menu items
   */
  renderLayout () {
    return (
      <div className="outer">
        <Header routerData={this.props.routerData} leftMenuItems={this.navItems} />
        <div className="main-container">
          <LeftMenu leftMenuItems={this.navItems} routerData={this.props.routerData} />

          <div className="right-column dashboard-bg">
            <Switch>
              {routes.map((route, idx) => {
                return route.component ? (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                      <route.component routerData={this.props.routerData} />
                    )} />
                ) : (null);
              })}
              <Redirect from="/" to="/home/default" />
            </Switch>
          </div>
        </div>
      </div>
    );
  }

  /**
   * render loader
   */
  renderLoading () {
    return (
      <LoadingOverlay active={this.state.isLoading} customClass="full_page_loading_overlay">
      </LoadingOverlay>
    );
  }

  /**
   * render error occured during the operation.
   */
  renderError () {
    return (
      <div className="align-center">
        <p>{this.state.onLoadErrorMsg}</p>
        <p>{i18n.t('home.defaultView.messages.noUserInfo')}</p>
        <button type="button" className="btn btn-primary"
          onClick={this.goToLogin.bind(this)}>
          {i18n.t('home.defaultView.button.goToLogin')}
        </button>
      </div>
    );
  }

  /**
   * shows error occured during menu item load.
   */
  renderErrorOnMenuItemsLoad () {
    return (
      <div className="align-center">
        <p>{this.state.onLoadErrorMsg}</p>
        <button type="button" className="btn btn-primary"
          onClick={this.goToLogin.bind(this)}>
          {i18n.t('home.defaultView.button.goToLogin')}
        </button>
      </div>
    );
  }

  /**
   * shows unauthorization error if user is not authorized for any operation.
   */
  renderUnauthorisedMessage () {
    return (
      <div className="align-center">
        <p data-testid="user-not-authorized-msg">
          {i18n.t('home.defaultView.messages.notAuthorized')}
        </p>
        <button type="button" className="btn btn-primary"
          onClick={this.goToLogin.bind(this)}>
          {i18n.t('home.defaultView.button.goToLogin')}
        </button>
      </div>
    );
  }

  /**
   * go to login page
   */
  goToLogin () {
    AppStorageHelper.clearApplicationData();
    this.goToScreen(SCREENS.login);
  }

  /**
   * react render function
   */
  render () {
    if (this.state.isLoading) {
      return this.renderLoading();
    } else {
      if (this.state.isErrorOnLoad) {
        return this.renderError();
      } else if (this.state.isErrorOnMenuItemsLoad) {
        return this.renderErrorOnMenuItemsLoad();
      } else if (this.state.isAuthorizedForCustomerPortal) {
        return this.renderLayout();
      } else {
        return this.renderUnauthorisedMessage();
      }
    }
  }
}

const mapDispatchToProps = {
  updateUserInfo,
  getSelectedAccHolder
};

export default connect(null, mapDispatchToProps)(DefaultLayout);
